module.exports = __webpack_public_path__ + "assets/img/s2-tab-2-dc345da6.png";